import { Component, OnInit } from '@angular/core';
import { ClearProjectAction } from '../projects/projects.action';
import { initialConfig } from '../shared/domain/initialConfig';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { LanguageService } from '../../shared/services/language.service';

@Component({
  selector: 'cc-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  constructor(
    private crazyCallConfigService: CrazyCallConfigService,
    private store: Store<IState>,
    public languageService: LanguageService
  ) {}

  ngOnInit() {
    this.store.dispatch(
      new ClearProjectAction(
        initialConfig(this.crazyCallConfigService.appId, this.languageService.getCookieLanguage() || 'en')
      )
    );
  }
}
